export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const customerOnboardingService = 'http://10.145.48.88:8072/api/v1';
export const customerService = 'http://10.145.48.88:8071/api/v1';
// export const customerServiceV2 = process.env.REACT_APP_CONSUMER_SERVICE;
export const customerServiceV2 = window['env']['graphqlBaseUrl'];
export const optionProfile = {
  INFO: 'info',
  PERSONAL_ADDRESS: 'personaladdress',
  CARD_ADDRESS: 'cardaddress',
  DEFAULT: 'default',
};
export const awsAccessKeyID = 'AKIA2GSTTDP6XT452LWD';
export const awsSecretAccessKey = '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';
export const awsBucketName = 'opw-apollo';
export const awsRegion = 'ap-southeast-1';

export const appId = {
  data: {
    // appId: process.env.REACT_APP_APP_ID,
    appId: window['env']['appId'],
    platform: 'WEB',
    // secretKey: process.env.REACT_APP_SECRET_KEY,
    secretKey: window['env']['secretKey'],
  },
};
